var bumpButtons = '[data-admin-bump-button]';

function bindButtonAjax() {
  $(document).on('ajax:success', bumpButtons, function (_e, xhr) {
    var button = $(this);
    button.replaceWith(xhr);
  });
  $(document).on('ajax:error', bumpButtons, function (xhr, status, error) {
    var button = $(this);
    button.replaceWith('Error');
  });
}

module.exports = {
  init: bindButtonAjax,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/admin/bump.js